$(document).ready(function () {
    $('[class*="cke"]')
        .contents()
        .each(function () {
            if (this.nodeType === 3 && $.trim($(this).text()) !== '') {
                var text = $(this).text();

                var textSegments = text
                    .split(/\n\s*\n/)
                    .filter(function (segment) {
                        return $.trim(segment) !== '';
                    });

                if (textSegments.length > 0) {
                    var wrappedText = textSegments
                        .map(function (segment) {
                            return '<p>' + $.trim(segment) + '</p>';
                        })
                        .join('');

                    $(this).replaceWith(wrappedText);
                }
            } else if (this.nodeType !== 3 && this.nodeName === 'BR') {
                $(this).remove();
            }
        });
});
